import React, { useEffect, useRef, useState } from 'react';
import { Music2, Pause } from 'lucide-react';
import { createDiscoSynth } from '../lib/discoSynth';

// Faixa própria: coloque o arquivo em public/audio/flashback.mp3 (com licença de uso).
// Sem o arquivo, toca a batida gerada no navegador.
const TRACK_SRC = `${process.env.PUBLIC_URL}/audio/flashback.mp3`;

// Som só com clique: navegador bloqueia autoplay e som inesperado faz a pessoa
// fechar a aba antes de ver a oferta.
const SoundToggle = () => {
  const [playing, setPlaying] = useState(false);
  const audio = useRef(null);
  const synth = useRef(null);
  const useSynth = useRef(false);

  useEffect(() => {
    document.documentElement.dataset.disco = playing ? 'on' : 'off';
  }, [playing]);

  useEffect(
    () => () => {
      audio.current?.pause();
      synth.current?.close();
    },
    []
  );

  const start = async () => {
    if (!useSynth.current) {
      if (!audio.current) {
        audio.current = new Audio(TRACK_SRC);
        audio.current.loop = true;
        audio.current.volume = 0.5;
      }
      try {
        await audio.current.play();
        return;
      } catch {
        useSynth.current = true; // arquivo ausente ou formato inválido
      }
    }
    if (!synth.current) synth.current = createDiscoSynth();
    await synth.current.start();
  };

  const toggle = async () => {
    if (playing) {
      audio.current?.pause();
      synth.current?.stop();
      setPlaying(false);
      return;
    }
    try {
      await start();
      setPlaying(true);
    } catch {
      setPlaying(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={playing}
      data-testid="sound-toggle"
      className="fixed bottom-24 left-4 z-30 inline-flex items-center gap-2 rounded-full border border-line bg-page/80 px-4 py-2.5 text-sm font-semibold text-ink backdrop-blur-lg transition-colors hover:border-ink/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent active:scale-[0.98] md:bottom-6 md:left-auto md:right-6"
    >
      {playing ? <Pause size={16} aria-hidden="true" /> : <Music2 size={16} aria-hidden="true" />}
      <span>{playing ? 'Pausar som' : 'Tocar flashback'}</span>
      {playing && (
        <span className="disco-eq" aria-hidden="true">
          <i />
          <i />
          <i />
        </span>
      )}
    </button>
  );
};

export default SoundToggle;
